import { render, staticRenderFns } from "./Contribution.vue?vue&type=template&id=44dbb00c&"
import script from "./Contribution.vue?vue&type=script&lang=js&"
export * from "./Contribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports